// app/javascript/controllers/secondary_modules_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  selectAll() {
    this.#setAllChecked(true)
  }

  removeAll() {
    this.#setAllChecked(false)
  }

  #setAllChecked(checked) {
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = checked
    })
  }
}
